import "./src/index.scss"

// disable all scroll restoration and load at top of page
export function shouldUpdateScroll() {
  return false;
}
